import { TemplateElement, html, toString, defineElement, BaseElement } from '@webtides/element-js';
import Panzoom from '@panzoom/panzoom';

export default class PanZoom extends BaseElement {
    constructor() {
        super();
        this._drag = false;
    }

    properties() {
        return {
            selector: 'img',
            defaultClickScale: 3,
            forceDefaultClickScale: true,
            maxScale: 10,
            minScale: 1,
            disableZoom: false,
        };
    }

    connected() {
        this._element = this.querySelector(this.selector);

        this._panzoom = new Panzoom(this._element, {
            maxScale: this.maxScale,
            minScale: this.minScale,
            disableZoom: this.disableZoom,
            contain: 'outside',
            cursor: this.disableZoom ? 'default' : 'zoom-in',
            overflow: 'visible',
        });
        this.reset();
    }

    reset() {
        this._panzoom.reset();
    }

    events() {
        return {
            this: {
                wheel: event => {
                    this._panzoom.zoomWithWheel(event);
                },
                click: event => {
                    if (this._drag) {
                        return;
                    }

                    if (this._panzoom.getScale() !== this.minScale) {
                        this._panzoom.reset();
                    } else {
                        let clickScale = this.defaultClickScale;
                        if (this._element.naturalWidth && this.forceDefaultClickScale === false) {
                            //TODO this will not zoom to 100% as intendet
                            clickScale = this._element.naturalWidth / this._element.offsetWidth || 3;
                        }
                        this._panzoom.zoomToPoint(clickScale, event);
                    }
                },
            },
            [this.selector]: {
                load: () => {
                    if (this._panzoom) {
                        this._panzoom.destroy();
                    }
                    this._panzoom = new Panzoom(this._element, {
                        maxScale: this.maxScale,
                        minScale: this.minScale,
                        disableZoom: this.disableZoom,
                        contain: 'outside',
                        cursor: this.disableZoom ? 'default' : 'zoom-in',
                        overflow: 'visible',
                    });
                    this.reset();
                },
                panzoomstart: () => {
                    this._drag = false;
                },
                panzoompan: () => {
                    this._drag = true;
                },
                panzoomzoom: () => {
                    this._element.style.cursor = 'grab';
                },
                panzoomreset: () => {
                    this._element.style.cursor = 'zoom-in';
                },
            },
        };
    }
}

defineElement('pan-zoom', PanZoom);
